module.exports = __webpack_public_path__ + "assets/FamilyAccidentTemplate-949b987e529b59d5170e5c5e45d7a262.xlsx";